import {
    FETCH_ACTUAL_BOOKINGS,
    FETCH_ACTUAL_BOOKINGS_SUCCESS,
    FETCH_TEMPORY_BOOKINGS,
    FETCH_TEMPORY_BOOKINGS_SUCCESS,
    CREATE_CONSULTATION,
    CREATE_CONSULTATION_SUCCESS
  } from "../constants/new.consultaion.constants";
  import { startLoader } from 'actions/general.action';

  export const fetchActualBookings = () => {
    return {
      type: FETCH_ACTUAL_BOOKINGS,
    };
  };
  
  export const getActualBookingsSuccess = (actual_bookings) => {
    return {
      type: FETCH_ACTUAL_BOOKINGS_SUCCESS,
      actual_bookings: actual_bookings,
    };
  };

  export const fetchTemporyBookings = () => {
    return {
      type: FETCH_TEMPORY_BOOKINGS,
    };
  };
  
  export const getTemporyBookingsSuccess = (tempory_bookings) => {
    return {
      type: FETCH_TEMPORY_BOOKINGS_SUCCESS,
      tempory_bookings: tempory_bookings,
    };
  };

  export const createConsultation = (payload) => {
    return dispatch => {
      dispatch({
        type: CREATE_CONSULTATION,
        payload: payload
      })
      dispatch(startLoader())
    }
  }
  
  export const createConsultationSuccess = (payload) => {
    return {
      type: CREATE_CONSULTATION_SUCCESS,
      payload: payload,
    };
  };

